import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { T } from '../Translation/index';

const TIPS = [
  'scan_process_1',
  'scan_process_2',
  'scan_process_3',
  'scan_process_4',
  'scan_process_5',
  'scan_process_6',
  'scan_process_7',
];

const TIP_DURATION = 8000; // 8 seconds each

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  margin: 8px auto 0 auto;
`;

const TipBubble = styled.div`
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 15px;
  text-align: center;
  white-space: normal;
  max-width: 750px;
  width: 90%;
  animation: fadeInOut 8s ease-in-out infinite;

  @keyframes fadeInOut {
    0%   { opacity: 0; }
    10%  { opacity: 1; }
    80%  { opacity: 1; }
    100% { opacity: 0; }
  }
`;

interface ScanTipsProps {
  active: boolean;
  showIdle?: boolean;
}

const ScanTips: React.FC<ScanTipsProps> = ({ active, showIdle }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!active) {
      setIndex(0);
      return;
    }
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % TIPS.length);
    }, TIP_DURATION);
    return () => clearInterval(interval);
  }, [active]);

  if (!active && !showIdle) return null;

  return (
    <Overlay>
      <TipBubble key={active ? index : 'idle'}>
        <T id={active ? TIPS[index] : 'scan_idle_tip'} />
      </TipBubble>
    </Overlay>
  );
};

export default ScanTips;
